import React, { useEffect, useState } from 'react';
import oncology from '../images/oncology.png';
import diabetes from '../images/cancer.png';
import rare from '../images/drop.png';

import { MdArrowForward } from 'react-icons/md';


const PipelineTable = () => {
  const data = [
    { indication: "Immuno-oncology", target: "NRP1", progress: { enabling: 50 }, icon: oncology },
    { indication: "Oncology", target: "CDK2", progress: { enabling: 50 }, icon: oncology },
    { indication: "Oncology", target: "PAD4", progress: { enabling: 30 }, icon: oncology },
    { indication: "Immuno-oncology", target: "Undisclosed", progress: { enabling: 30 }, icon: oncology },
    { indication: "Type 2 Diabetes", target: "Undisclosed", progress: { enabling: 30 }, icon: diabetes },
    { indication: "Angelman syndrome", target: "Undisclosed", progress: { enabling: 30 }, icon: rare },
  ];

  // State to control animated width
  const [progressWidths, setProgressWidths] = useState(data.map(() => 0));

  useEffect(() => {
    const timeout = setTimeout(() => {
      setProgressWidths(data.map(row => row.progress.enabling));
    }, 100); // Delay to trigger animation

    return () => clearTimeout(timeout);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="w-full min-h-screen bg-black text-white font-sofia px-4 sm:px-8 lg:px-16 xl:px-20 py-12">
      <div className="max-w-[1440px] mx-auto">
        <h3 className="text-5xl font-bold mb-8 text-[#6FC5F0] text-center">Pipeline</h3>
        <p className="text-lg mb-10 leading-relaxed">
          Our drug discovery pipeline encompasses six active projects, advancing from hit discovery to the preclinical stage. 
          Among these, three are internal initiatives, while the remaining three are collaborative efforts with leading academic 
          and industry partners. Our research spans key therapeutic areas, including oncology, metabolic disorders, and rare 
          diseases. By tackling some of the most challenging targets in the industry, we continuously enhance our AI-driven 
          platforms, optimizing their capabilities to accelerate the development of transformative therapies.
        </p>

<div className="relative">
  {/* Scroll (visible only on small screens) */}
  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 pointer-events-none block md:hidden">
  <MdArrowForward className="text-white text-4xl drop-shadow animate-bounce-right" />
  </div>

  {/* Scrollable Table */}
  <div className="overflow-x-auto">
    <table className="min-w-full table-auto border-separate border-spacing-0 text-lg border-2 border-gray-200 rounded-lg">
      <thead className="bg-black">
        <tr>
          <th className="px-4 py-4 text-center text-[#6FC5F0] text-2xl border-b border-gray-700 border-r border-gray-700">Disease Indication</th>
          <th className="px-4 py-4 text-center text-[#6FC5F0] text-2xl border-b border-gray-700 border-r border-gray-700">Target</th>
          <th className="px-4 py-4 text-center text-[#6FC5F0] text-2xl border-b border-gray-700 border-r border-gray-700">Discovery</th>
          <th className="px-4 py-4 text-center text-[#6FC5F0] text-2xl border-b border-gray-700 border-r border-gray-700">Lead Optimization</th>
          <th className="px-4 py-4 text-center text-[#6FC5F0] text-2xl border-b border-gray-700">Ind - Enabling</th>
        </tr>
      </thead>
      <tbody>
        {data.map((row, index) => (
          <tr key={index} className="border-t border-gray-700">
            <td className="px-4 py-3 flex items-center text-left border-r border-gray-700">
              <img src={row.icon} alt={`${row.indication} icon`} className="w-8 h-8 mr-3" />
              <span className="text-xl">{row.indication}</span>
            </td>
            <td className="px-4 py-3 text-center border-r border-gray-700 text-xl">{row.target}</td>
            <td colSpan="3" className="px-4 py-3 border-l border-gray-700">
              <div className="bg-gray-700 h-3.5 rounded-full relative w-full border border-gray-800">
                <div
                  className="absolute top-0 left-0 h-3.5 bg-gradient-to-r from-orange-500 to-purple-500 rounded-full transition-all duration-[3000ms] ease-in-out"
                  style={{ width: `${progressWidths[index]}%` }}
                ></div>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

      </div>
    </section>
  );
};

export default PipelineTable;
